import { Box, Container, Flex, Image, Button } from "@theme-ui/components"
import React, { useState, useContext, useEffect } from "react"

import { getHomePath, getSearchPath } from "../utils/path"
import { InboundLink } from "./link"
import { useColorMode } from "theme-ui"

import { MagicLink } from "../utils/magicLink"
import LanguageSwitcher from "./languageSwitcher"
import { debounce } from "lodash"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { MenuContext } from "../context/menuContext"
import Logo from "../images/logo-rgb.svg"
import LogoWhite from "../images/logo-white.svg"
import LogoWhiteBlack from "../images/diginnova-white-barra-nera.svg"
import { motion, AnimateSharedLayout, color } from "framer-motion"

const Nav = ({ primaryNav, background }) => {
  const [isInverted, setIsInverted] = useState(false)
  const [colorMode, setColorMode] = useColorMode()
  const [isDark, setIsDark] = useState(false)
  console.log(colorMode)
  const menu = useContext(MenuContext)

  const locale = React.useContext(LanguageSwitcherContext).activeLocale

  menu.map(menuItem => {
    menuItem.treeChildren.sort((a, b) => a.position - b.position)
    menuItem.treeChildren.map(menuItem => {
      if (menuItem.treeChildren.length > 0) {
        menuItem.treeChildren.sort((a, b) => a.position - b.position)
      }
    })
  })

  useEffect(() => {
    colorMode === "dark" ? setIsDark(true) : setIsDark(false)
  }, [colorMode])
  function toggleColorMode() {
    setColorMode(colorMode === "dark" ? "default" : "dark")
    console.log("toogleColorMode", colorMode)
  }
  console.log(colorMode)
  return (
    <Box
      as="nav"
      sx={{
        backgroundColor:
          primaryNav === true
            ? "primary"
            : background === "#eeeeee"
            ? "lightGrey"
            : "light",
      }}
    >
      <Container variant="header" sx={{ paddingX: [3, 4] }}>
        <Flex
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ paddingX: 2, paddingY: 4 }}>
            <InboundLink to={getHomePath(locale)} className="logo-link">
              {console.log("imageColormode", colorMode)}
              <motion.img
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                src={primaryNav ? LogoWhiteBlack : isDark ? LogoWhite : Logo}
                alt="Logo"
              />
            </InboundLink>
          </Box>
          <Flex sx={{ alignContent: "center", alignItems: "center" }}>
            <Flex
              sx={{
                backgroundColor: "dark",
                borderRadius: "40px",
                paddingX: 0,
                paddingY: 0,
                flexDirection: "row",
                listStyle: "none",
                a: {
                  textDecoration: "none",
                  letterSpacing: "1px",
                  fontWeight: 400,
                  fontSize: [0, 1, 1, "12px"],
                  textTransform: "uppercase",
                  color: "light",
                },
              }}
              as="ul"
            >
              {menu.map(item => (
                <TextComponent item={item} locale={locale} key={item.id} />
              ))}
            </Flex>
          </Flex>
          <Box
            sx={{
              backgroundColor: background
                ? background.hex
                : primaryNav === true
                ? "primary"
                : "light",
              borderRadius: "40px",
              width: "100px",
              height: "50px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 10px",
              position: "relative",
            }}
          >
            <motion.div
              style={{
                position: "absolute",
                right: "25%",
              }}
            >
              <Button
                onClick={() => toggleColorMode()}
                sx={{
                  borderColor: "dark",
                  backgroundColor: "dark",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  "&:hover": {
                    backgroundColor: "dark",
                  },
                }}
              />
            </motion.div>

            <motion.div style={{ position: "absolute", left: "0px" }}>
              <Button
                onClick={() => toggleColorMode()}
                sx={{
                  border: "1px solid black",
                  borderColor: "dark",
                  backgroundColor: "light",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  "&:hover": {
                    backgroundColor: "light",
                  },
                }}
              />
            </motion.div>
          </Box>
        </Flex>
      </Container>
    </Box>
  )
}

const TextComponent = ({ item, locale, index }) => {
  const [show, setShow] = useState(false)

  const debouncedHandleMouseEnterMenu = debounce(() => {
    setShow(true)
  }, 200)

  const handlOnMouseLeaveMenu = () => {
    setShow(false)
    debouncedHandleMouseEnterMenu.cancel()
  }
  console.log(locale)
  return (
    <Box
      as="li"
      key={item.id}
      sx={{
        position: "relative",
        a: {
          fontSize: [0, 1, 1, "15px"],
          paddingX: 3,
          paddingY: 3,
          display: "block",
          fontWeight: 400,
          borderRadius: "40px",
          ":hover": {
            fontWeight: 500,
            backgroundColor: "primary",
            color: "dark",
            transition: "background-color 200ms ease-out",
          },
        },
        "a.active": {
          fontWeight: 500,
          backgroundColor: "primary",
          color: "dark",
        },
      }}
      onMouseEnter={() => debouncedHandleMouseEnterMenu()}
      onMouseLeave={() => handlOnMouseLeaveMenu()}
    >
      {item.link ? (
        <MagicLink item={item.link} locale={locale}></MagicLink>
      ) : (
        <Box sx={{ cursor: "default" }}>{item.anchor}</Box>
      )}
      {item.treeChildren.length > 0 && show && (
        <Box
          as="ul"
          sx={{
            backgroundColor: "dark",
            listStyle: "none",
            padding: 3,
            margin: 0,
            backgroundColor: "lightBackground",
            position: "absolute",
            top: 40,
            width: "max-content",

            boxShadow:
              "0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%)",
            borderRadius: "sm",
          }}
        >
          {item.treeChildren.map(item =>
            item.anchor ? (
              <Box as="li" key={item.id} sx={{}}>
                {item.link ? (
                  <MagicLink item={item.link} locale={locale} />
                ) : (
                  <Box sx={{ cursor: "default" }}>{item.anchor}</Box>
                )}
              </Box>
            ) : null
          )}
        </Box>
      )}
    </Box>
  )
}

export default Nav
